export default function init_sevenrooms() {
  const trigger = document.getElementById('sr-res-root');

  document.querySelectorAll('.booking-button').forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();

      trigger.click();
    });
  });
}